import React from 'react';

const SvgQuestion = props => (
  <svg
    id="question_svg__Layer_1"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <style>{'.question_svg__cls-1{fill:#999}'}</style>
    </defs>
    <g id="question_svg__help-circle">
      <path
        className="question_svg__cls-1"
        d="M12.06 20.58A8.58 8.58 0 1120.63 12a8.58 8.58 0 01-8.57 8.58zm0-15.4a6.82 6.82 0 106.8 6.82 6.82 6.82 0 00-6.8-6.82z"
        id="question_svg__Oval"
      />
      <path
        className="question_svg__cls-1"
        d="M12 13.65a.87.87 0 01-.83-.6.88.88 0 01.55-1.12c.56-.19 1.7-.8 1.7-1.47a1.42 1.42 0 00-2.76-.46A.88.88 0 119 9.4a3.19 3.19 0 011.62-1.82 3.13 3.13 0 012.44-.13 3.18 3.18 0 012.13 3c0 2.11-2.61 3-2.91 3.15a.86.86 0 01-.28.05z"
        id="question_svg__Path"
      />
      <path
        className="question_svg__cls-1"
        d="M12.06 16.73a.9.9 0 01-.62-.26.83.83 0 01-.25-.62.88.88 0 01.25-.63.91.91 0 011.25 0 .93.93 0 01.25.63.89.89 0 01-.25.62.9.9 0 01-.63.26z"
        id="question_svg__Path-2"
      />
    </g>
  </svg>
);

export default SvgQuestion;
